import { forwardRef } from 'react';

import ChainIcon from '@/components/ChainIcon';
import { Button, ButtonProps } from '@/components/shadcn/ui/button';
import { cn } from '@/utils';
import { truncateMidAddressInputValue } from '@/utils/truncateAddress';

import { useDogeWallet } from '../../../hooks/useDogeWallet';

export const ConnectedDogeWalletButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, ...props }, ref) => {
    const { address } = useDogeWallet();
    const resultAddress = truncateMidAddressInputValue(address!);

    return (
      <Button
        ref={ref}
        size="sm"
        variant="secondary"
        className={cn('font-roboto rounded-xl font-bold', className)}
        {...props}
      >
        {children || (
          <div className="flex items-center gap-1 text-sm sm:gap-2">
            <ChainIcon src="/chains/doge.svg" />
            <div className="hidden sm:block">{resultAddress}</div>
          </div>
        )}
      </Button>
    );
  }
);

ConnectedDogeWalletButton.displayName = 'ConnectedDogeWalletButton';
